import { Grid } from "@mui/material";
import React, { forwardRef } from "react";
import { useSelector } from "react-redux";
import Accordian from "../../StyleComponent/Accordian";
import BillCalculation from "./BillCalculation/BillCalculation";
import BillList from "./BillList/BillList";
import DueManagement from "./DueManagement/DueManagement";
import ServicePriceList from "./ServicePriceList/ServicePriceList";

// react-select-5-listbox

const BillingSection = forwardRef((props, ref) => {
  
  // const childRef = useRef();
  // useImperativeHandle(ref, () => ({
  //   getAlert() {
  //     alert("getAlert from Child");
  //   },
  // }));
  const refreshBillList  = (patientId)=>{
    // alert("From BIll section"+patientId)
    console.log(ref)
    ref.billListRef.current.getOrderListByPatientId(patientId); 
  }
  
  const refreshDueBillList  = (patientId)=>{
    // alert("From BIll section"+patientId)
    console.log(ref)
    ref.dueListRef.current.getDueOrderList(patientId);
  }
  
  

  const patientId = useSelector((state) => state.patientId);
  
  return (
    <Accordian
      headerBgColor="#49FF00"
      titleColor="#ffffff"
      title="Bill Management"
    >
       
      {/* {patientId && (
        
      )} */}
      <div id="billingSection" style={{display: patientId ? "block":  "none"}}>
          {/* //onClick={() => childRef.current.getAlert() */}
          {/* <button onClick={()=>childRef.current.resetFormBillCalculation()}>Clear data </button> */}
        {/* {
          billCalc()
        } */}
          <DueManagement ref={ref} ></DueManagement>
          <Grid  container spacing={2}>
            <Grid item xs={12} md={6}>
              {/* ------------------------------------------------------------- Invoice Calculation  */}
              {/* <BillCalculation  ></BillCalculation> */}
              <BillCalculation ref={ref} refreshBillList={refreshBillList} refreshDueBillList={refreshDueBillList} ></BillCalculation>
              {/* ------------------------------------------------------------- Invoice Calculation  */}
            </Grid>
            <Grid item xs={6}>
              {/* ------------------------------------------------------------- PRICE CHART  */}
              <ServicePriceList  ></ServicePriceList>
              {/* ------------------------------------------------------------- PRICE CHART END */}
            </Grid>
          </Grid>
          <BillList ref={ref}></BillList>
        </div>
    </Accordian>
  );
});

export default BillingSection;
